import { kebabCase } from "lodash";
import { Preferences } from "./preferences.model";

export const LoginType = Object.freeze({
  Simple: 0,
  GoogleSSO: 1,
  MicrosoftSSO: 2,
  CleverSSO: 3,
  ClassLinkSSO: 4,
  AppleSSO: 5,
  0: "Simple",
  1: "GoogleSSO",
  2: "MicrosoftSSO",
  3: "CleverSSO",
  4: "ClassLinkSSO",
  5: "AppleSSO",
});

export class UserInfo {
  #id;
  #email;
  #createdDate;
  #groupLicenseLevel;
  #groupAdmins;
  #groupId;
  #groupName;
  #groupRole;
  #groupPreferences;
  #userAvatar;
  #publisherId;
  #publisherName;
  #publisherRole;
  #publisherDetails;
  #roles;

  constructor({
    userName,
    userId,
    email,
    acceptedMISTerms,
    registrationdate,
    collectionCount,
    isCategoriesSelected,
    groupLicenseKey,
    groupAdminEmails,
    groupId,
    groupRole,
    groupName,
    groupPreference,
    userAvatar,
    publisherId,
    publisherName,
    publisherRole,
    publisherDetails,
    roles,
  }) {
    this.#id = userId;
    this.#email = email;
    this.#createdDate = registrationdate;
    this.#groupLicenseLevel = groupLicenseKey;
    this.#groupAdmins = groupAdminEmails;
    this.#groupId = groupId;
    this.#groupName = groupName;
    this.#groupRole = groupRole;
    this.username = userName;
    this.acceptedMisTerms = acceptedMISTerms;
    this.collectionCount = collectionCount;
    this.isCategoriesSelected = isCategoriesSelected;
    this.#userAvatar = userAvatar;
    this.#publisherId = publisherId;
    this.#publisherName = publisherName;
    this.#publisherRole = publisherRole;
    this.#publisherDetails = publisherDetails;
    this.#roles = roles;
    this.#groupPreferences = {};
    if (groupPreference != null) {
      for (let i = 0; i < groupPreference.length; i++) {
        const preference = groupPreference[i];
        const preferenceId = kebabCase(preference.name);
        switch (preferenceId) {
          case "hide-quick-search":
            if (this.#groupPreferences[Preferences.HIDE_QUICK_SEARCH] == null) {
              this.#groupPreferences[Preferences.HIDE_QUICK_SEARCH] = {};
            }
            this.#groupPreferences[Preferences.HIDE_QUICK_SEARCH][
              preference.groupLicenseKey
            ] = preference.value;
            break;
          default:
            break;
        }
      }
    }
  }

  get id() {
    return this.#id;
  }
  get email() {
    return this.#email;
  }
  get createdDate() {
    return this.#createdDate;
  }
  get gradeLicenseLevel() {
    return this.#groupLicenseLevel;
  }
  get groupAdmins() {
    return this.#groupAdmins;
  }
  get groupId() {
    return this.#groupId;
  }
  get groupName() {
    return this.#groupName;
  }
  get groupPreferences() {
    return this.#groupPreferences;
  }
  get groupRole() {
    return this.#groupRole;
  }
  get userAvatar() {
    return this.#userAvatar;
  }
  get publisherId() {
    return this.#publisherId;
  }
  get publisherName() {
    return this.#publisherName;
  }
  get publisherRole() {
    return this.#publisherRole;
  }

  get publisherDetails() {
    return this.#publisherDetails;
  }

  get roles() {
    return this.#roles;
  }
}
